// extracted by mini-css-extract-plugin
export var actionButton = "_rf-0";
export var actionMenuContainer = "_rf-i";
export var bubble = "_rf-2";
export var bubbleActionMenu = "_rf-j";
export var bubbleContext = "_rf-6";
export var bubbleItems = "_rf-7";
export var customer = "_rf-3";
export var divider = "_rf-8";
export var fileList = "_rf-9";
export var hiddenComment = "_rf-o";
export var infoAbove = "_rf-a";
export var internal = "_rf-4";
export var lightActionButton = "_rf-1";
export var link = "_rf-b";
export var merchant = "_rf-5";
export var message = "_rf-c";
export var profilePicture = "_rf-e";
export var quillToolbarContainer = "_rf-f";
export var senderDate = "_rf-g";
export var senderDateCustomer = "_rf-h";
export var senderName = "_rf-d";
export var time = "_rf-k";
export var uploadedImage = "_rf-l";
export var username = "_rf-m";
export var xsmall = "_rf-n";